module.exports = __webpack_public_path__ + "img/need-help.6030f9ae.svg";